import React from 'react';
import rtl from 'jss-rtl';
import rtlPlugin from 'stylis-plugin-rtl';
import {
	BrowserRouter,
	Link,
	Navigate,
	Route,
	Router,
	Routes,
} from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { heIL } from '@mui/material/locale';
import { StylesProvider, jssPreset } from '@mui/styles';
import { create } from 'jss';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import './App.css';

import { LayerContextProvider } from '../components/context/LayerContext';
import Main from './Main';

import AddSpot from './AddSpot';
import Search from './Search';

export default function App() {
	const theme = createTheme(
		{
			direction: 'rtl',
			palette: {
				primary: { main: '#1976d2' },
			},
			typography: {
				fontFamily: [
					'Assistant',
					'BlinkMacSystemFont',
					'"Segoe UI"',
					'Roboto',
					'"Helvetica Neue"',
					'Arial',
					'sans-serif',
					'"Apple Color Emoji"',
					'"Segoe UI Emoji"',
					'"Segoe UI Symbol"',
				].join(','),
			},
		},
		heIL
	);
	const jss = create({
		plugins: [...jssPreset().plugins, rtl()],
	});

	// Create rtl cache
	const cacheRtl = createCache({
		key: 'muirtl',
		stylisPlugins: [rtlPlugin],
	});
	return (
		<CacheProvider value={cacheRtl}>
			<StylesProvider jss={jss}>
				<ThemeProvider theme={theme}>
					<LayerContextProvider>
						<BrowserRouter>
							<Routes>
								{/* <Route path="/" element={<Navigate to="/search" />} /> */}
								<Route path="/" element={<Search />} />
								{/* <Route path="search" element={<Search />} /> */}
								<Route path="main" element={<Main />} />
								<Route path="add" element={<AddSpot />} />
								{/* <Route path={`${path}main`}>
							 	<Main />
							 </Route>
							 <Route path={`${path}main2`} component={Main} /> */}
							</Routes>
						</BrowserRouter>
					</LayerContextProvider>
				</ThemeProvider>
			</StylesProvider>
		</CacheProvider>
	);
}
